module.exports = __webpack_public_path__ + "static/media/Big_Cloud_Up_Green.1806f783.bmp";